export const PROJECTS_ACTION_TYPES = {
  FETCH_PROJECTS_START: 'projects/FETCH_PROJECTS_START',
  FETCH_PROJECTS_SUCCESS: 'projects/FETCH_PROJECTS_SUCCESS',
  FETCH_PROJECTS_FAILED: 'projects/FETCH_PROJECTS_FAILED',
};